/**
 * Created by fwt on 2019/7/30.
 */
import React,{Component} from "react"
import {NavBar, Tabs, Toast} from 'antd-mobile';
import {discountList} from '../../../service/memberService';
import './style.less';
import {connect} from "react-redux";
@connect(
    state => ({userInfo: state.userInfo})
)
export default class Discounts extends Component{
    constructor(props) {
        super(props);
        this.state={
            tabs : [
                { title:"未使用"},
                { title: "已使用" },
                { title: "已过期" }
            ],
            unusedData:[],
            usedData:[],
            expiredData:[],
            usedIndex:true,
            expiredIndex:true,
        }
    }

    componentDidMount() {
        this.getDiscountsList(1);
    }
    getDiscountsList(type){
        let params = {
            source:1,
            token:this.props.userInfo.token,
            data:{type:type}
        };
        if(type == 1){
            Toast.loading("正在加载", 0);
        }
        discountList(params).then((res)=>{
            if (res.data.code === '0000') {
                Toast.hide();
                if(type == 1){
                    this.setState({unusedData:res.data.data})
                }
                if(type == 2){
                    this.setState({usedData:res.data.data})
                }
                if(type == 3){
                    this.setState({expiredData:res.data.data})
                }
            }else{
                Toast.info(res.data.msg,2)
            }
        });
    }
    tabChange(e,index){
            if(index == 1){
            this.setState({usedIndex:false})
        }
        if(index == 2){
            this.setState({expiredIndex:false})
        }
        if(this.state.usedIndex || this.state.expiredIndex){
            this.getDiscountsList(index+1);
        }
    }
    render() {
        return (
            <div className="discounts">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() =>this.props.history.goBack()}/>}
                >我的优惠券</NavBar>
                <Tabs prerenderingSiblingsNumber={false} tabs={this.state.tabs} swipeable={false} onChange={(e,index)=>this.tabChange(e,index)}>
                    {
                        this.state.unusedData.length > 0 ?
                             this.state.unusedData.map((res,i)=>(
                                <div className="unused" key={i}>
                                    <div className="list">
                                        <div className="left">
                                            {res.couponType == 1 ? <p className="pic">￥<span>{parseFloat(res.couponAmount).toFixed(2)}</span></p> : <p className="pic"><span>{res.couponRatio * 10}</span> 折</p>}
                                            {res.limitType == 1 ? <p>无限制</p> :<p>满{parseInt(res.useLimitAmount)}可用</p>}
                                        </div>
                                        <div className="right">
                                            <p className="title">{res.couponName}</p>
                                            <p className="time">有效期：{res.allotTime}</p>
                                            <div>
                                                <span>{res.lineName == '全部线路' ? "全部线路可用" : "部分线路可用"}</span>
                                                <span onClick={()=>this.props.history.push(`/discountsInfo/${res.id}`)}>规则明细 <i className="icon iconfont icontiaozhuan1"/> </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                            :<div style={{textAlign: "center", paddingTop: "36px"}}>暂无数据</div>
                    }
                    {
                        this.state.usedData.length > 0 ?
                            this.state.usedData.map((res,i)=>(
                                <div className="unused used" key={i}>
                                    <div className="list">
                                        <div className="left">
                                            {res.couponType == 1 ? <p className="pic">￥<span>{parseFloat(res.couponAmount).toFixed(2)}</span></p> : <p className="pic"><span>{res.couponRatio * 10}</span> 折</p>}
                                            {res.limitType == 1 ? <p>无限制</p> :<p>满{parseInt(res.useLimitAmount)}可用</p>}
                                        </div>
                                        <div className="right">
                                            <p className="title">{res.couponName}</p>
                                            <p className="time">有效期：{res.allotTime}</p>
                                            <div>
                                                <span>{res.lineName == '全部线路' ? "全部线路可用" : "部分线路可用"}</span>
                                                <span onClick={()=>this.props.history.push(`/discountsInfo/${res.id}`)}>规则明细 <i className="icon iconfont icontiaozhuan1"/> </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                            :<div style={{textAlign: "center", paddingTop: "36px"}}>暂无数据</div>
                    }
                    {
                        this.state.expiredData.length > 0 ?
                            this.state.expiredData.map((res,i)=>(
                                <div className="unused expired"  key={i}>
                                    <div className="list">
                                        <div className="left">
                                            {res.couponType == 1 ? <p className="pic">￥<span>{parseFloat(res.couponAmount).toFixed(2)}</span></p> : <p className="pic"><span>{res.couponRatio * 10}</span> 折</p>}
                                            {res.limitType == 1 ? <p>无限制</p> :<p>满{parseInt(res.useLimitAmount)}可用</p>}
                                        </div>
                                        <div className="right">
                                            <p className="title">{res.couponName}</p>
                                            <p className="time">有效期：{res.allotTime}</p>
                                            <div>
                                                <span>{res.lineName == '全部线路' ? "全部线路可用" : "部分线路可用"}</span>
                                                <span onClick={()=>this.props.history.push(`/discountsInfo/${res.id}`)}>规则明细 <i className="icon iconfont icontiaozhuan1"/> </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                            :<div style={{textAlign: "center", paddingTop: "36px"}}>暂无数据</div>
                    }
                    {/*<div className="unused used">
                        <div className="list">
                            <div className="left">
                                <p className="pic">￥<span>50</span></p>
                                <p>满200可用</p>
                            </div>
                            <div className="right">
                                <p className="title">新用户注册专享券</p>
                                <p className="time">有效期：2019.05.11 — 2019.07.30</p>
                                <div>
                                    <span>部分线路可用</span>
                                    <span>规则明细 <i className="icon iconfont icontiaozhuan1"/> </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="unused expired">
                        <div className="list">
                            <div className="left">
                                <p className="pic">￥<span>50</span></p>
                                <p>满200可用</p>
                            </div>
                            <div className="right">
                                <p className="title">新用户注册专享券</p>
                                <p className="time">有效期：2019.05.11 — 2019.07.30</p>
                                <div>
                                    <span>部分线路可用</span>
                                    <span>规则明细 <i className="icon iconfont icontiaozhuan1"/> </span>
                                </div>
                            </div>
                        </div>
                    </div>*/}
                </Tabs>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/member/Discounts/index.js